import { getUsernameForBarcodeResource } from "../resource/ScanBarcodeResource";
import { COMMON_ACTIONS } from "../constants/ActionType";

export const INVALID_BARCODE = "INVALID_BARCODE";
export const getAssociateStatusByBarcodeScan = async (
  ScanBarcodeDispatch,
  barcode,
) => {
  try {
    const barcodeResponse = await getUsernameForBarcodeResource(barcode);
    if (barcodeResponse.status === 200) {
      return barcodeResponse.data.username;
    } else {
      ScanBarcodeDispatch({ type: INVALID_BARCODE });
    }
  } catch (error) {
    ScanBarcodeDispatch({ type: COMMON_ACTIONS.SERVER_FAILURE });
  }
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/action/scanBarcodeAction.js